// extracted by mini-css-extract-plugin
export default {"article":"Article_article__s2SAe","edit":"Article_edit__7Uaex"};